(function(){
  window.WagWalkOnTrack=window.WagWalkOnTrack||function(eventName,detail){
    var payload=Object.assign({event:eventName,page_path:window.location.pathname},detail||{});
    try{if(window.Shopify&&Shopify.analytics&&typeof Shopify.analytics.publish==='function')Shopify.analytics.publish(eventName,payload);}catch(e){}
    try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(payload);}catch(e){}
    try{document.dispatchEvent(new CustomEvent('wagwalkon:'+eventName,{detail:payload}));}catch(e){}
  };
  function qs(sel, root){return (root||document).querySelector(sel)}
  function qsa(sel, root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}

  function setMobileMenu(open){
    var toggle=qs('[data-mobile-menu-toggle]');
    var close=qs('[data-mobile-menu-close]');
    document.body.classList.toggle('menu-open',open);
    if(toggle)toggle.setAttribute('aria-expanded',open?'true':'false');
    if(open&&close)close.focus();
    if(!open&&toggle)toggle.focus();
  }

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-thumb]');
    if(t){var main=qs('[data-main-image]'); if(main&&t.dataset.src){main.src=t.dataset.src; qsa('[data-thumb]').forEach(function(x){x.classList.remove('is-active')}); t.classList.add('is-active')}}
    var menu=e.target.closest('[data-mobile-menu-toggle]');
    if(menu){setMobileMenu(!document.body.classList.contains('menu-open'))}
    var close=e.target.closest('[data-mobile-menu-close]');
    if(close){setMobileMenu(false)}
    var smooth=e.target.closest('a[href^="#"]');
    if(smooth && smooth.getAttribute('href').length>1){var target=qs(smooth.getAttribute('href')); if(target){e.preventDefault(); target.scrollIntoView({behavior:'smooth',block:'start'}); if(document.body.classList.contains('menu-open'))setMobileMenu(false)}}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&document.body.classList.contains('menu-open'))setMobileMenu(false);
  });

  function initProductForm(form){
    var productJsonEl=qs('[data-product-json]', form.closest('[data-product-root]')||document);
    if(!productJsonEl) return;
    var product; try{product=JSON.parse(productJsonEl.textContent)}catch(e){return}
    var idInput=qs('input[name="id"]', form), priceEl=qs('[data-product-price]', form.closest('[data-product-root]')), addBtn=qs('[data-add-button]', form), buyNowBtn=qs('[data-buy-now-button]',form);
    function selectedOptions(){
      return qsa('[data-option-group]', form).map(function(group){
        var checked=qs('input[type="radio"]:checked', group); return checked ? checked.value : '';
      });
    }
    function findVariant(opts){
      return product.variants.find(function(v){return v.options.every(function(o,i){return o===opts[i]})});
    }
    function money(cents){
      if(window.Shopify&&Shopify.formatMoney){return Shopify.formatMoney(cents, window.themeMoneyFormat || '${{amount}}')}
      return '$'+(cents/100).toFixed(2)
    }
    function update(){
      var v=findVariant(selectedOptions());
      if(!v) return;
      if(idInput) idInput.value=v.id;
      if(priceEl) priceEl.textContent=money(v.price);
      if(addBtn){addBtn.disabled=!v.available; addBtn.textContent=v.available?(addBtn.dataset.available||'Add to cart'):(addBtn.dataset.soldout||'Sold out')}
      if(buyNowBtn){buyNowBtn.disabled=!v.available;buyNowBtn.textContent=v.available?'Buy It Now':'Sold Out'}
      if(v.featured_image&&v.featured_image.src){var main=qs('[data-main-image]'); if(main) main.src=v.featured_image.src}
      var url=new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({},'',url.toString());
    }
    qsa('[data-variant-radio]', form).forEach(function(r){r.addEventListener('change',update)}); update();
    form.addEventListener('submit',function(event){
      var preview=form.querySelector('[data-ai-preview]');
      var directCheckout=!!(event.submitter&&event.submitter.hasAttribute('data-buy-now-button'));
      window.WagWalkOnTrack(directCheckout?'buy_now_after_preview':'add_to_cart_after_preview',{
        product_id:product.id,
        variant_id:idInput?idInput.value:'',
        preview_generated:!!(preview&&preview.classList.contains('has-preview'))
      });
    });
  }
  qsa('[data-product-form]').forEach(initProductForm);
})();

// Keep the preview action within reach on mobile without covering the form itself.
(function(){
  function initPreviewJump(root){
    var preview=root.querySelector('.order-step-card--upload');
    var sticky=root.querySelector('[data-mobile-preview-sticky]');
    if(!preview)return;
    root.querySelectorAll('[data-preview-jump],[data-mobile-preview-sticky]').forEach(function(link){
      if(link.dataset.previewJumpReady)return;
      link.dataset.previewJumpReady='true';
      link.addEventListener('click',function(){
        preview.open=true;
        if(window.WagWalkOnTrack)window.WagWalkOnTrack('preview_cta_click',{placement:link.hasAttribute('data-mobile-preview-sticky')?'mobile_sticky':'product_hero'});
      });
    });
    if(sticky&&'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(entry){sticky.classList.toggle('is-hidden',entry.isIntersecting);});
      },{threshold:.08}).observe(preview);
    }
  }
  function ready(){document.querySelectorAll('[data-product-root]').forEach(initPreviewJump);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();

// On desktop, place customer stories below the gallery so both columns use the available space.
// On mobile, return the section to its original position after the purchase controls.
(function(){
  var desktopQuery=window.matchMedia('(min-width: 901px)');
  function placeReviews(root){
    var gallery=root.querySelector('.product-gallery');
    var reviews=root.querySelector('#product-customer-reviews');
    var home=root.querySelector('[data-product-reviews-home]');
    if(!gallery||!reviews||!home)return;
    if(desktopQuery.matches){
      if(reviews.parentNode!==gallery)gallery.appendChild(reviews);
    }else if(home.parentNode&&reviews.previousElementSibling!==home){
      home.parentNode.insertBefore(reviews,home.nextSibling);
    }
  }
  function placeAll(){document.querySelectorAll('[data-product-root]').forEach(placeReviews);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',placeAll);else placeAll();
  if(desktopQuery.addEventListener)desktopQuery.addEventListener('change',placeAll);else desktopQuery.addListener(placeAll);
  document.addEventListener('shopify:section:load',function(event){
    var root=event.target.matches&&event.target.matches('[data-product-root]')?event.target:event.target.querySelector('[data-product-root]');
    if(root)placeReviews(root);
  });
})();

// Product reviews: show seven initially, then expand or collapse the rest.
(function(){
  function initReviewToggle(toggle){
    if(toggle.dataset.reviewsToggleReady)return;
    toggle.dataset.reviewsToggleReady='true';
    var section=toggle.closest('.product-customer-reviews');
    if(!section)return;
    var extraReviews=Array.prototype.slice.call(section.querySelectorAll('.product-review-card--extra'));
    var label=toggle.querySelector('[data-reviews-toggle-label]');
    if(!extraReviews.length){toggle.hidden=true;return;}
    toggle.addEventListener('click',function(){
      var expanded=toggle.getAttribute('aria-expanded')==='true';
      extraReviews.forEach(function(review){review.hidden=expanded;});
      toggle.setAttribute('aria-expanded',expanded?'false':'true');
      if(label)label.textContent=expanded?'Show more reviews':'Show fewer reviews';
      if(expanded)section.scrollIntoView({behavior:'smooth',block:'start'});
    });
  }
  function ready(){document.querySelectorAll('[data-reviews-toggle]').forEach(initReviewToggle);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();
(function(){
  function qsa(sel, root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  function qs(sel, root){return (root||document).querySelector(sel)}
  document.addEventListener('click',function(e){
    var prev=e.target.closest('[data-carousel-prev]'), next=e.target.closest('[data-carousel-next]');
    if(prev||next){var shell=e.target.closest('.carousel-shell'); var track=qs('[data-carousel-track]', shell); if(track){var amount=track.clientWidth*.82; track.scrollBy({left:prev?-amount:amount,behavior:'smooth'});}}
    var media=e.target.closest('.main-media');
    if(media&&e.target.matches('[data-main-image]')){var box=qs('.lightbox'); if(box){qs('img',box).src=e.target.src; box.classList.add('is-open')}}
    var close=e.target.closest('[data-lightbox-close]'); if(close){close.closest('.lightbox').classList.remove('is-open')}
  });
})();
(function(){
  function qsa(sel, root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  function qs(sel, root){return (root||document).querySelector(sel)}

  document.addEventListener('change', function(e){
    var input = e.target.closest('[data-file-input]');
    if(!input) return;
    var field = input.closest('.custom-upload-field');
    if(!field) return;
    var hasFile = input.files && input.files.length > 0;
    var nameEl = qs('[data-file-name]', field);
    var titleEl = qs('[data-upload-title]', field);
    var iconEl = qs('[data-upload-icon]', field);
    if(nameEl) nameEl.textContent = hasFile ? input.files[0].name : 'Click to choose a clear front-facing photo';
    if(titleEl) titleEl.textContent = hasFile ? 'Photo selected' : 'Upload pet photo';
    if(iconEl) iconEl.textContent = hasFile ? '✓' : '＋';
    field.classList.toggle('has-file', !!hasFile);
  });

  function initMobileSlider(wrap){
    var slider = qs('[data-mobile-product-slider]', wrap);
    if(!slider) return;
    var slides = qsa('.mobile-product-slide', slider);
    var dots = qsa('[data-mobile-slide-dot]', wrap);
    var count = qs('[data-mobile-slide-count]', wrap);
    if(!slides.length) return;
    function setActive(index){
      index = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach(function(dot, i){dot.classList.toggle('is-active', i === index)});
      if(count) count.textContent = (index + 1) + ' / ' + slides.length;
    }
    dots.forEach(function(dot){
      dot.addEventListener('click', function(){
        var index = parseInt(dot.getAttribute('data-index') || '0', 10);
        var slide = slides[index];
        if(slide) slider.scrollTo({left: slide.offsetLeft, behavior: 'smooth'});
        setActive(index);
      });
    });
    var timer;
    slider.addEventListener('scroll', function(){
      clearTimeout(timer);
      timer = setTimeout(function(){
        var index = 0;
        var min = Infinity;
        slides.forEach(function(slide, i){
          var distance = Math.abs(slide.offsetLeft - slider.scrollLeft);
          if(distance < min){min = distance; index = i;}
        });
        setActive(index);
      }, 60);
    }, {passive:true});
    setActive(0);
  }
  qsa('.mobile-product-slider-wrap').forEach(initMobileSlider);
})();


// v53 product image zoom modal
(function(){
  var modal=document.querySelector('[data-image-zoom-modal]');
  if(!modal) return;
  var img=modal.querySelector('[data-image-zoom-img]');
  var lastFocus=null;
  function openZoom(source){
    if(!source || !img) return;
    lastFocus=document.activeElement;
    img.src=source.getAttribute('data-zoom-src') || source.currentSrc || source.src;
    img.alt=source.getAttribute('alt') || 'Product image preview';
    modal.hidden=false;
    document.documentElement.classList.add('image-zoom-open');
    document.body.classList.add('image-zoom-open');
    var close=modal.querySelector('[data-image-zoom-close]');
    if(close) close.focus({preventScroll:true});
  }
  function closeZoom(){
    modal.hidden=true;
    if(img) img.src='';
    document.documentElement.classList.remove('image-zoom-open');
    document.body.classList.remove('image-zoom-open');
    if(lastFocus && lastFocus.focus) lastFocus.focus({preventScroll:true});
  }
  document.addEventListener('click',function(e){
    var source=e.target.closest('[data-zoomable]');
    if(source){
      e.preventDefault();
      openZoom(source);
      return;
    }
    if(e.target.closest('[data-image-zoom-close]')) closeZoom();
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape' && !modal.hidden) closeZoom();
  });
})();


// v55 finished photo slider controls
(function(){
  function qsa(sel, root){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function init(track){
    if(!track || track.dataset.finishedSliderReady) return;
    track.dataset.finishedSliderReady='true';
    var wrap=track.closest('.finished-photo-shell') || track.closest('.product-finished-photos') || track.parentElement;
    var dotsWrap=wrap ? wrap.querySelector('[data-finished-photo-dots], [data-product-finished-photo-dots]') : null;
    var slides=qsa('.finished-photo-card', track);
    if(!slides.length) return;
    function activeIndex(){
      var center=track.scrollLeft + track.clientWidth/2;
      var idx=0, best=Infinity;
      slides.forEach(function(slide,i){
        var sc=slide.offsetLeft + slide.offsetWidth/2;
        var d=Math.abs(sc-center);
        if(d<best){best=d; idx=i;}
      });
      return idx;
    }
    function setDots(){
      if(!dotsWrap) return;
      var idx=activeIndex();
      qsa('button',dotsWrap).forEach(function(dot,i){dot.classList.toggle('is-active',i===idx);});
    }
    if(dotsWrap && !dotsWrap.children.length){
      slides.forEach(function(slide,i){
        var b=document.createElement('button');
        b.type='button';
        b.setAttribute('aria-label','Go to photo '+(i+1));
        b.addEventListener('click',function(){track.scrollTo({left:slide.offsetLeft-18,behavior:'smooth'});});
        dotsWrap.appendChild(b);
      });
    }
    var timer;
    track.addEventListener('scroll',function(){clearTimeout(timer); timer=setTimeout(setDots,50);},{passive:true});
    var down=false,startX=0,startLeft=0,moved=false;
    track.addEventListener('pointerdown',function(e){
      if(e.pointerType==='touch') return;
      down=true; moved=false; startX=e.clientX; startLeft=track.scrollLeft; track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove',function(e){
      if(!down) return;
      var dx=e.clientX-startX;
      if(Math.abs(dx)>4) moved=true;
      track.scrollLeft=startLeft-dx;
    });
    function end(e){
      if(!down) return;
      down=false; track.classList.remove('is-dragging');
      try{track.releasePointerCapture(e.pointerId);}catch(err){}
      setDots();
      setTimeout(function(){moved=false;},0);
    }
    track.addEventListener('pointerup',end);
    track.addEventListener('pointercancel',end);
    track.addEventListener('click',function(e){if(moved){e.preventDefault(); e.stopPropagation();}}, true);
    var prev=wrap ? wrap.querySelector('[data-carousel-prev]') : null;
    var next=wrap ? wrap.querySelector('[data-carousel-next]') : null;
    function go(dir){
      var idx=activeIndex()+dir;
      idx=Math.max(0,Math.min(idx,slides.length-1));
      track.scrollTo({left:slides[idx].offsetLeft-18,behavior:'smooth'});
    }
    if(prev && !prev.dataset.finishedBound){prev.dataset.finishedBound='true'; prev.addEventListener('click',function(e){e.preventDefault(); go(-1);});}
    if(next && !next.dataset.finishedBound){next.dataset.finishedBound='true'; next.addEventListener('click',function(e){e.preventDefault(); go(1);});}
    setDots();
  }
  qsa('.finished-photo-track').forEach(init);
})();


// v56 homepage photo sliders
(function(){
  function qsa(sel, root){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function initSlider(track, dotSelector){
    if(!track || track.dataset.homeSliderReady) return;
    track.dataset.homeSliderReady='true';
    var wrap=track.closest('.home-photo-slider') || track.closest('.carousel-shell') || track.parentElement;
    var dotsWrap=wrap ? wrap.querySelector(dotSelector || '[data-home-photo-dots]') : null;
    var slides=qsa('.home-photo-card, .before-after-carousel-card', track);
    if(!slides.length) return;
    function activeIndex(){
      var center=track.scrollLeft+track.clientWidth/2;
      var idx=0,best=Infinity;
      slides.forEach(function(slide,i){
        var sc=slide.offsetLeft+slide.offsetWidth/2;
        var d=Math.abs(sc-center);
        if(d<best){best=d;idx=i;}
      });
      return idx;
    }
    function setDots(){
      if(!dotsWrap) return;
      var idx=activeIndex();
      qsa('button',dotsWrap).forEach(function(dot,i){dot.classList.toggle('is-active',i===idx);});
    }
    if(dotsWrap && !dotsWrap.children.length){
      slides.forEach(function(slide,i){
        var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Go to photo '+(i+1));
        b.addEventListener('click',function(){track.scrollTo({left:slide.offsetLeft-18,behavior:'smooth'});});
        dotsWrap.appendChild(b);
      });
    }
    var timer;
    track.addEventListener('scroll',function(){clearTimeout(timer);timer=setTimeout(setDots,50);},{passive:true});
    var down=false,startX=0,startLeft=0,moved=false;
    track.addEventListener('pointerdown',function(e){if(e.pointerType==='touch') return; down=true;moved=false;startX=e.clientX;startLeft=track.scrollLeft;track.classList.add('is-dragging');track.setPointerCapture(e.pointerId);});
    track.addEventListener('pointermove',function(e){if(!down) return;var dx=e.clientX-startX;if(Math.abs(dx)>4)moved=true;track.scrollLeft=startLeft-dx;});
    function end(e){if(!down)return;down=false;track.classList.remove('is-dragging');try{track.releasePointerCapture(e.pointerId);}catch(err){}setDots();setTimeout(function(){moved=false;},0);}
    track.addEventListener('pointerup',end); track.addEventListener('pointercancel',end);
    track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
    var prev=wrap?wrap.querySelector('[data-carousel-prev]'):null, next=wrap?wrap.querySelector('[data-carousel-next]'):null;
    function go(dir){var idx=Math.max(0,Math.min(activeIndex()+dir,slides.length-1));track.scrollTo({left:slides[idx].offsetLeft-18,behavior:'smooth'});}
    if(prev && !prev.dataset.homeSliderBound){prev.dataset.homeSliderBound='true';prev.addEventListener('click',function(e){e.preventDefault();go(-1);});}
    if(next && !next.dataset.homeSliderBound){next.dataset.homeSliderBound='true';next.addEventListener('click',function(e){e.preventDefault();go(1);});}
    setDots();
  }
  qsa('[data-home-photo-track]').forEach(function(track){initSlider(track,'[data-home-photo-dots]');});
  qsa('.before-after [data-carousel-track]').forEach(function(track){initSlider(track,'[data-home-photo-dots]');});
})();


// v57 video showcase slider
(function(){
  function qsa(sel, root){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function init(track){
    if(!track || track.dataset.videoSliderReady) return;
    track.dataset.videoSliderReady='true';
    var wrap=track.closest('.video-showcase__shell') || track.parentElement;
    var dotsWrap=wrap ? wrap.querySelector('[data-video-showcase-dots]') : null;
    var slides=qsa('.video-showcase__card', track);
    if(!slides.length) return;
    function activeIndex(){
      var center=track.scrollLeft+track.clientWidth/2;
      var idx=0,best=Infinity;
      slides.forEach(function(slide,i){
        var sc=slide.offsetLeft+slide.offsetWidth/2;
        var d=Math.abs(sc-center);
        if(d<best){best=d;idx=i;}
      });
      return idx;
    }
    function setActive(){
      var idx=activeIndex();
      if(dotsWrap) qsa('button',dotsWrap).forEach(function(dot,i){dot.classList.toggle('is-active',i===idx);});
      slides.forEach(function(slide,i){
        if(i!==idx){qsa('video',slide).forEach(function(v){try{v.pause();}catch(e){}});}
      });
    }
    if(dotsWrap && !dotsWrap.children.length){
      slides.forEach(function(slide,i){
        var b=document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Go to video '+(i+1));
        b.addEventListener('click',function(){track.scrollTo({left:slide.offsetLeft-18,behavior:'smooth'});});
        dotsWrap.appendChild(b);
      });
    }
    var timer;
    track.addEventListener('scroll',function(){clearTimeout(timer); timer=setTimeout(setActive,70);},{passive:true});
    var down=false,startX=0,startLeft=0,moved=false;
    track.addEventListener('pointerdown',function(e){if(e.pointerType==='touch') return; down=true;moved=false;startX=e.clientX;startLeft=track.scrollLeft;track.classList.add('is-dragging');track.setPointerCapture(e.pointerId);});
    track.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-startX;if(Math.abs(dx)>4)moved=true;track.scrollLeft=startLeft-dx;});
    function end(e){if(!down)return;down=false;track.classList.remove('is-dragging');try{track.releasePointerCapture(e.pointerId);}catch(err){}setActive();setTimeout(function(){moved=false;},0);}
    track.addEventListener('pointerup',end); track.addEventListener('pointercancel',end);
    track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
    var prev=wrap?wrap.querySelector('[data-carousel-prev]'):null, next=wrap?wrap.querySelector('[data-carousel-next]'):null;
    function go(dir){var idx=Math.max(0,Math.min(activeIndex()+dir,slides.length-1));track.scrollTo({left:slides[idx].offsetLeft-18,behavior:'smooth'});}
    if(prev && !prev.dataset.videoBound){prev.dataset.videoBound='true';prev.addEventListener('click',function(e){e.preventDefault();go(-1);});}
    if(next && !next.dataset.videoBound){next.dataset.videoBound='true';next.addEventListener('click',function(e){e.preventDefault();go(1);});}
    setActive();
  }
  qsa('[data-video-showcase-track]').forEach(init);
})();

// AI preview generator on product page
(function(){
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}
  function getResultUrl(data){return data&&(data.imageUrl||data.image_url||data.url)||'';}
  ready(function(){
    document.querySelectorAll('[data-ai-preview]').forEach(function(card){
      if(card.dataset.aiPreviewReady)return;card.dataset.aiPreviewReady='true';
      var endpoint=(card.dataset.endpoint||'').trim(),form=card.closest('form'),fileInput=(form&&form.querySelector('[data-ai-preview-file]'))||document.querySelector('[data-ai-preview-file]'),petNameInput=(form&&form.querySelector('[data-ai-preview-pet-name]'))||document.querySelector('[data-ai-preview-pet-name]'),eyeStateInputs=form?form.querySelectorAll('[data-ai-preview-eye-state]'):document.querySelectorAll('[data-ai-preview-eye-state]'),emailBox=card.querySelector('[data-ai-preview-email-box]'),emailInput=(form&&form.querySelector('[data-ai-preview-email]'))||card.querySelector('[data-ai-preview-email]'),emailSubmit=card.querySelector('[data-ai-preview-email-submit]'),emailModal=card.querySelector('[data-ai-preview-email-modal]'),modalEmailInput=card.querySelector('[data-ai-preview-modal-email]'),modalEmailSubmit=card.querySelector('[data-ai-preview-modal-email-submit]'),button=card.querySelector('[data-ai-preview-button]'),status=card.querySelector('[data-ai-preview-status]'),image=card.querySelector('[data-ai-preview-image]'),nextStep=card.querySelector('[data-ai-preview-next-step]'),continueButton=card.querySelector('[data-ai-preview-continue]'),history=card.querySelector('[data-ai-preview-history]'),historyGrid=card.querySelector('[data-ai-preview-history-grid]'),property=card.querySelector('[data-ai-preview-property]');
      if(!button)return;
      function setStatus(text,isError){if(status){status.textContent=text||'';status.hidden=!text;}card.classList.toggle('has-error',!!isError);}
      function validEmail(value){return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value||'');}
      function getPetName(){return petNameInput&&petNameInput.value?petNameInput.value.trim():'';}
      function getEyeState(){var selected=null;if(eyeStateInputs){eyeStateInputs.forEach(function(input){if(input.checked)selected=input;});}return selected&&selected.value?selected.value:'Same as Photo';}
      function promptPetName(){setStatus('Please enter your pet’s name before generating the preview.',true);if(petNameInput)petNameInput.focus();}
      function appendPetName(payload,petName){payload.append('petName',petName);payload.append('pet_name',petName);payload.append('name',petName);payload.append('properties[Pet name]',petName);}
      function getSelectedSize(){var value='';if(form){var checked=form.querySelector('[data-variant-radio]:checked');if(checked)value=checked.value||'';if(!value){var selected=form.querySelector('select[name^=\"options\"] option:checked');if(selected)value=selected.value||'';}}var match=String(value).toUpperCase().match(/XXL|XL|\bL\b|\bM\b/);return match?match[0]:'M';}
      function appendSelectedSize(payload){var size=getSelectedSize();payload.append('size',size);payload.append('urnSize',size);payload.append('selectedSize',size);payload.append('properties[Selected urn size]',size);}
      function appendEyeState(payload,eyeState){var isResting=eyeState==='Resting Peacefully';var eyePrompt=isResting?'IMPORTANT: The customer selected Resting Peacefully. Generate the memorial preview with the pet gently sleeping, both eyes fully closed. Do not show open, half-open, or alert eyes.':'Match the pet expression from the uploaded photo.';payload.append('eyeState',eyeState);payload.append('eye_state',eyeState);payload.append('petEyePreference',eyeState);payload.append('expression',eyeState);payload.append('petExpression',eyeState);payload.append('previewExpression',eyeState);payload.append('eyePrompt',eyePrompt);payload.append('pet_eye_prompt',eyePrompt);payload.append('prompt',eyePrompt);payload.append('additionalPrompt',eyePrompt);payload.append('instructions',eyePrompt);payload.append('customization',eyePrompt);payload.append('notes',eyePrompt);payload.append('properties[Pet eye preference]',eyeState);payload.append('properties[Preview expression instruction]',eyePrompt);}
      function addPreviewHistory(url){if(!history||!historyGrid||!url)return;var item=document.createElement('img');item.className='ai-preview-history__item';item.src=url;item.alt='Previous AI preview';item.addEventListener('click',function(){if(image){image.src=url;image.hidden=false;image.removeAttribute('hidden');image.style.display='block';}if(property)property.value=url;card.classList.add('has-preview');});history.hidden=false;history.removeAttribute('hidden');historyGrid.insertBefore(item,historyGrid.firstChild);}
      function resetPreviewForNewUpload(){card.classList.remove('has-preview','has-error','is-loading');card.dataset.emailReminderShown='';if(image){image.hidden=true;image.removeAttribute('src');image.style.display='';}if(nextStep)nextStep.hidden=true;if(property)property.value='';if(status){status.textContent='';status.hidden=true;status.style.display='';}if(button){button.hidden=false;button.disabled=false;button.style.display='';button.textContent='Create My Free Preview';}if(emailSubmit&&card.dataset.emailSaved!=="true"){emailSubmit.disabled=false;emailSubmit.textContent='Send Preview to My Email';}}
      function openEmailModal(){if(card.classList.contains('has-preview')||card.dataset.emailSaved==='true'||card.dataset.emailReminderShown==='true')return;card.dataset.emailReminderShown='true';if(emailModal){emailModal.hidden=false;emailModal.removeAttribute('hidden');document.body.classList.add('ai-preview-email-modal-open');if(modalEmailInput){modalEmailInput.value=emailInput&&emailInput.value?emailInput.value:'';setTimeout(function(){modalEmailInput.focus();},50);}}else if(emailBox){emailBox.open=true;if(emailInput)emailInput.focus();}}
      function closeEmailModal(){if(emailModal){emailModal.hidden=true;document.body.classList.remove('ai-preview-email-modal-open');}}
      function submitPreviewEmail(sourceInput,sourceButton){var email=sourceInput&&sourceInput.value?sourceInput.value.trim():'';if(!email){setStatus('Please enter your email address first.',true);if(sourceInput)sourceInput.focus();return;}if(!validEmail(email)){setStatus('Please enter a valid email address.',true);if(sourceInput)sourceInput.focus();return;}if(!fileInput||!fileInput.files||!fileInput.files[0]){setStatus('Please upload a pet photo first.',true);return;}var petName=getPetName();if(!petName){promptPetName();return;}var emailEndpoint=endpoint.replace(/\/api\/preview(?:\?.*)?$/,'/api/preview-email-request');var emailPayload=new FormData();emailPayload.append('image',fileInput.files[0],fileInput.files[0].name||'pet-photo.jpg');appendPetName(emailPayload,petName);appendEyeState(emailPayload,getEyeState());appendSelectedSize(emailPayload);emailPayload.append('email',email);emailPayload.append('customerEmail',email);emailPayload.append('notifyEmail',email);emailPayload.append('productUrl',window.location.href);emailPayload.append('source','preview_email_button');if(emailInput)emailInput.value=email;if(modalEmailInput)modalEmailInput.value=email;if(sourceButton){sourceButton.disabled=true;sourceButton.textContent='Saving…';}setStatus('Saving your email. We’ll send the preview when it’s ready.',false);fetch(emailEndpoint,{method:'POST',body:emailPayload}).then(function(res){if(!res.ok)throw new Error('Could not save your email. Please try again.');return res.json();}).then(function(){card.dataset.emailSaved='true';window.WagWalkOnTrack('preview_email_submitted',{preview_generated:card.classList.contains('has-preview')});if(sourceButton)sourceButton.textContent='Email Saved';if(emailSubmit){emailSubmit.textContent='Email Saved';emailSubmit.disabled=true;}if(modalEmailSubmit){modalEmailSubmit.textContent='Email Saved';modalEmailSubmit.disabled=true;}closeEmailModal();setStatus('Thank you — your email is saved. You can leave this page and we’ll send the preview when it’s ready.',false);}).catch(function(err){if(sourceButton){sourceButton.disabled=false;sourceButton.textContent='Send Preview to My Email';}setStatus(err&&err.message?err.message:'Could not save your email. Please try again.',true);});}
      function showEmailReminder(){if(card.classList.contains('has-preview'))return;openEmailModal();setStatus('Still creating your preview. If you don’t want to keep waiting, add your email and we’ll send it when it’s ready.',false);}
      if(emailSubmit){emailSubmit.addEventListener('click',function(){submitPreviewEmail(emailInput,emailSubmit);});}
      if(modalEmailSubmit){modalEmailSubmit.addEventListener('click',function(){submitPreviewEmail(modalEmailInput,modalEmailSubmit);});}
      if(emailModal){emailModal.addEventListener('click',function(e){if(e.target&&e.target.matches('[data-ai-preview-email-modal-close]'))closeEmailModal();});}
      if(fileInput){fileInput.addEventListener('change',function(){resetPreviewForNewUpload();if(fileInput.files&&fileInput.files[0])window.WagWalkOnTrack('photo_upload_complete',{file_type:fileInput.files[0].type||'unknown',file_size_bucket:fileInput.files[0].size>5000000?'over_5mb':'up_to_5mb'});});}
      if(eyeStateInputs){eyeStateInputs.forEach(function(input){input.addEventListener('change',resetPreviewForNewUpload);});}
      document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden'&&card.classList.contains('is-loading')&&!card.classList.contains('has-preview')&&card.dataset.emailSaved!=='true')openEmailModal();});
      window.addEventListener('pagehide',function(){if(card.classList.contains('is-loading')&&!card.classList.contains('has-preview')&&card.dataset.emailSaved!=='true')openEmailModal();});
      if(continueButton){continueButton.addEventListener('click',function(){var sizeStep=form&&form.querySelector('.order-step-card--size');if(sizeStep){sizeStep.open=true;sizeStep.scrollIntoView({behavior:'smooth',block:'start'});}else{var add=form&&form.querySelector('[data-add-button]');if(add)add.scrollIntoView({behavior:'smooth',block:'center'});}});}
      button.addEventListener('click',function(){
        if(!endpoint||endpoint.indexOf('your-worker-domain')>-1){setStatus('Preview service is not set. Please contact us if this message appears.',true);return;}
        if(!fileInput||!fileInput.files||!fileInput.files[0]){setStatus('Please upload a pet photo first.',true);return;}
        var petName=getPetName();if(!petName){promptPetName();return;}
        window.WagWalkOnTrack('preview_start',{selected_size:getSelectedSize(),eye_preference:getEyeState()});
        var payload=new FormData();payload.append('image',fileInput.files[0],fileInput.files[0].name||'pet-photo.jpg');appendPetName(payload,petName);appendEyeState(payload,getEyeState());appendSelectedSize(payload);payload.append('productUrl',window.location.href);var notifyEmail=emailInput&&emailInput.value?emailInput.value.trim():'';if(notifyEmail){payload.append('email',notifyEmail);payload.append('customerEmail',notifyEmail);payload.append('notifyEmail',notifyEmail);}
        var emailReminderTimer=setTimeout(showEmailReminder,15000);
        card.dataset.emailReminderShown='';
        card.classList.add('is-loading');card.classList.remove('has-preview');button.hidden=true;if(emailSubmit&&card.dataset.emailRequested==='true'){emailSubmit.disabled=true;emailSubmit.textContent='Sending…';}setStatus(notifyEmail?'⌛ Image generation takes 1–2 minutes. We’ll also send the preview to your email when it’s ready.':'⌛ Image generation takes 1–2 minutes. If you don’t want to wait, leave your email and we’ll send the preview when it’s ready.',false);
        fetch(endpoint,{method:'POST',body:payload}).then(function(res){if(!res.ok)throw new Error('Preview request failed. Please try again.');return res.json();}).then(function(data){var url=getResultUrl(data);if(!url)throw new Error('No preview image returned. Please try again.');if(image){image.onload=function(){window.WagWalkOnTrack('preview_viewed',{selected_size:getSelectedSize()});image.onload=null;};image.src=url;image.hidden=false;image.removeAttribute('hidden');image.style.display='block';}if(nextStep){nextStep.hidden=false;nextStep.removeAttribute('hidden');}if(property)property.value=url;addPreviewHistory(url);window.WagWalkOnTrack('preview_generated',{selected_size:getSelectedSize()});if(button){button.hidden=true;button.disabled=true;button.style.display='none';}if(emailSubmit&&card.dataset.emailRequested==='true'){emailSubmit.textContent='Preview Email Requested';emailSubmit.disabled=true;}if(status){status.textContent='';status.hidden=true;status.style.display='none';}card.classList.remove('is-loading');card.classList.add('has-preview');}).catch(function(err){if(button){button.hidden=false;button.disabled=false;button.style.display='';}if(emailSubmit){emailSubmit.disabled=false;emailSubmit.textContent='Send Preview to My Email';}if(status){status.style.display='';}setStatus(err&&err.message?err.message:'Preview failed. Please try again.',true);}).finally(function(){clearTimeout(emailReminderTimer);card.classList.remove('is-loading');if(!card.classList.contains('has-preview')){button.textContent='Create My Free Preview';}if(card.dataset.emailRequested==='true'&&!card.classList.contains('has-preview')){card.dataset.emailRequested='';}});
      });
    });
  });
})();
